var _ = { escape: require('lodash.escape') };
module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="profile__calendar__container calendar__container"><div class="profile__calendar__container__controls calendar__container__spinner"></div><div class="profile__calendar__container__controls calendar__container__controls"></div><div class="profile__calendar__container__content calendar__container__content"></div></div>';

}
return __p
};

/*
original source:

<div class="profile__calendar__container calendar__container">
    <div class="profile__calendar__container__controls calendar__container__spinner"></div>
    <div class="profile__calendar__container__controls calendar__container__controls"></div>
    <div class="profile__calendar__container__content calendar__container__content"></div>
</div>

*/
